// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d9f5cc2e","667":"2c892cda","977":"263bb9d9"}[chunkId] + ".chunk.js";
};